export default __webpack_public_path__ + "static/media/s-core.b161994c.jpg";